import { Flex, Heading } from '@chakra-ui/react';

/**
 * A desktop page's header: the title and the page's own actions on one 52px
 * row at the top of the content panel, a hairline below. `children` are the
 * actions, right-aligned; they wrap below the title when the panel is narrow.
 */
export default function PageHeader({ title, children, ...props }) {
  return (
    <Flex
      as="header"
      justify="space-between"
      align="center"
      wrap="wrap"
      gap={2}
      minH="52px"
      px={{ base: 3, md: 5 }}
      py={2}
      bg="redesign.bg.page"
      borderBottom="1px solid"
      borderColor="redesign.border"
      flexShrink={0}
      {...props}
    >
      <Heading as="h1" fontSize="14px" fontWeight={600} letterSpacing="tight" color="redesign.heading">
        {title}
      </Heading>
      {children && (
        <Flex align="center" gap={2} wrap="wrap">
          {children}
        </Flex>
      )}
    </Flex>
  );
}
